module.exports = __webpack_public_path__ + "img/Avatar-11.c8c87ef2.gif";